import { useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import MDAlert from "ui/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import karkunService from "services/karkun-service";
import { Card, FormControl, MenuItem, Select, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateClient } from "../../redux/actions/clientActions";
import { useParams } from "react-router-dom";
import centerService from "services/center-service";
import { IconButton, UpdateButton } from "../common/buttons";
import { ArrowDropDown } from "@mui/icons-material";
import roleService from "services/role-service";

const EditKarkun = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [centers, setCenters] = useState([]);
  const [karkun, setKarkun] = useState({
    name: "",
    fathername: "",
    phone: "",
    email: "",
    marfat: "",
    ehad: "",
    address: "",
    center: "",
    city: "",
    country: "",
  });

  const cityOptions = ["Lahore", "Karachi", "Islamabad"];
  const countryOptions = ["Pakistan", "UnitedKingdom"];

  const [errors, setErrors] = useState({
    nameError: false,
    fathernameError: false,
    phoneError: false,
    karkunidError: false,
    emailError: false,
    marfatError: false,
    ehadError: false,
    addressError: false,
    cityError: false,
    countryError: false,
    centerError: false,

  });

  useEffect(() => {
    const getRoles = async () => {
      var rolesData = await roleService.getAll();
      if (rolesData.success) {
        console.log('roles-data', rolesData.roles);
        setRoles(rolesData.roles);
      }
    }
    getRoles();
  }, []);



  useEffect(() => {
    const fetchcenters = async () => {
      const response = await centerService.getAll();
      if (response.success === true && response.centers) {
        console.log('Centers list:', response.centers);
        setCenters(response.centers);
      }
    };
    fetchcenters();

  }, []);

  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchKarkun = async () => {
      const response = await karkunService.getById(id);
      console.log("Karkun center value", response);
      if (response.success === true && response.karkun) {
        setKarkun({
          name: response.karkun?.name || '',
          phone: response.karkun?.phone || '',
          fathername: response.karkun?.fathername || '',
          address: response.karkun?.address || '',
          city: response.karkun?.city || '',
          country: response.karkun?.country || '',
          email: response.karkun?.email || '',
          marfat: response.karkun?.marfat || '',
          ehad: response.karkun?.ehad || '',
          center: response.karkun?.center || '',

        });
        setSelectedRole(response.karkun?.roleId || "");

      } else {
        setNotification({
          type: 'error',
          message: response.errors[0],
        });
      }
    };

    fetchKarkun();
  }, [id]);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const changeHandler = (e) => {
    setKarkun({
      ...karkun,
      [e.target.name]: e.target.value,
    });
  };



  const submitHandler = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({
      nameError: false,
      phoneError: false,
      fathernameError: false,
      addressError: false,
      cityError: false,
      countryError: false,
      emailError: false,
      marfatError: false,
      ehadError: false,
      centerError: false,
    });

    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Validate fields
    if (karkun.name.trim().length === 0) {
      setErrors({ ...errors, nameError: true });
      return;
    }

    if (karkun.fathername.trim().length === 0) {
      setErrors({ ...errors, fathernameError: true });
      return;
    }

    if (karkun.phone.trim().length === 0) {
      setErrors({ ...errors, phoneError: true });
      return;
    }

    if (karkun.marfat.trim().length === 0) {
      setErrors({ ...errors, marfatError: true });
      return;
    }

    if (!karkun.ehad || String(karkun.ehad).trim().length === 0) {
      setErrors({ ...errors, ehadError: true });
      return;
    }


    if (karkun.address.trim().length === 0) {
      setErrors({ ...errors, addressError: true });
      return;
    }

    if (karkun.city.trim().length === 0) {
      setErrors({ ...errors, cityError: true });
      return;
    }
    if (karkun.center.trim().length === 0) {
      setErrors({ ...errors, centerError: true });
      return;
    }

    if (karkun.country.trim().length === 0) {
      setErrors({ ...errors, countryError: true });
      return;
    }

    if (karkun.email.trim().length === 0 || !karkun.email.trim().match(mailFormat)) {
      setErrors((prev) => ({ ...prev, emailError: true }));
      return;
    }
    const karkunData = {
      name: karkun.name,
      fathername: karkun.fathername,
      phone: karkun.phone,
      email: karkun.email,
      marfat: karkun.marfat,
      ehad: karkun.ehad,
      address: karkun.address,
      city: karkun.city,
      country: karkun.country,
      center: karkun.center,
      roleId: selectedRole // 👈 add
    };
    console.log("Updating karkun with ID:", id, karkunData);

    setLoading(true);
    // Call API to update client
    const response = await karkunService.update(id, karkunData);
    console.log("sending data", karkunData);
    setLoading(false);

    if (response.success) {
      dispatch(updateClient(karkunData));
      setNotification({
        type: 'success',
        message: response.message,
      });
    } else {
      setNotification({
        type: 'error',
        message: response.errors[0],
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Edit Karkun
                </MDTypography>
                <UpdateButton loading={loading} onClick={submitHandler} />


              </MDBox>
              <MDBox
                component="form"
                role="form"
                onSubmit={submitHandler}
                display="flex"
                flexDirection="column"
                py={0}
                px={3}
              >
                {notification && (
                  <MDAlert color={notification.type} mt="20px">
                    <MDTypography variant="body2" color="white">
                      {notification.message}
                    </MDTypography>
                  </MDAlert>
                )}
                <MDBox display="flex" flexDirection="row" mt={5} mb={3}>


                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Name
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="name"
                        value={karkun?.name}
                        onChange={changeHandler}
                        error={errors.nameError}
                      />
                      {errors.nameError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Father Name
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="fathername"
                        value={karkun?.fathername}
                        onChange={changeHandler}
                        error={errors.fathernameError}
                      />
                      {errors.fathernameError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Father name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Contact
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="number"
                        fullWidth
                        name="phone"
                        value={karkun?.phone}
                        onChange={changeHandler}
                        error={errors.phoneError}
                      />
                      {errors.phoneError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Contact Number
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Email
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="email"
                        fullWidth
                        name="email"
                        value={karkun?.email}
                        onChange={changeHandler}
                        error={errors.emailError}
                      />
                      {errors.emailError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide email
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" flexDirection="row" mb={3}>


                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Address
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="address"
                        value={karkun?.address}
                        onChange={changeHandler}
                        error={errors.addressError}
                      />
                      {errors.addressError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Address
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      City
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="city"
                        value={karkun?.city || "Lahore"}
                        onChange={changeHandler}
                        error={errors.cityError}
                        sx={{ height: '45px' }}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >
                        {cityOptions.map((city) => (
                          <MenuItem key={city} value={city}>{city}</MenuItem>
                        ))}
                      </Select>

                      {errors.cityError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide a city
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Country
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="country"
                        value={karkun?.country || "Pakistan"} // Default to Pakistan
                        onChange={changeHandler}
                        displayEmpty
                        error={errors.countryError}
                        sx={{ height: '45px' }}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >

                        {countryOptions.map((country) => (
                          <MenuItem key={country} value={country}>{country}</MenuItem>
                        ))}
                      </Select>
                      {errors.countryError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide a country
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Arsa Ehad
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="ehad"
                        value={karkun?.ehad || ""}
                        onChange={changeHandler}
                        sx={{ height: '45px' }}

                        error={errors.ehadError}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >
                        {Array.from({ length: 50 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          );
                        })}
                      </Select>

                      {errors.ehadError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Arsa Ehad
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" flexDirection="row" mb={3}>



                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="24%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Marfat
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="marfat"
                        value={karkun?.marfat}
                        onChange={changeHandler}
                        error={errors.marfatError}
                      />
                      {errors.marfatError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide marfat name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>


                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="23%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Center
                    </MDTypography>
                    <MDBox mb={1} width="100%">
                      <FormControl fullWidth error={errors.centerError}>
                        <Select
                          labelId="role-label"
                          sx={{ height: '45px' }}
                          name="center"
                          value={karkun.center || "default"}
                          onChange={changeHandler}
                          IconComponent={() => (
                            <IconButton>
                              <ArrowDropDown />
                            </IconButton>
                          )}
                        >
                          <MenuItem value="default">Select Center</MenuItem>
                          {centers.map((center) => (
                            <MenuItem key={center.centerId} value={center.id}>
                              {center.name}
                            </MenuItem>
                          ))}
                        </Select>

                      </FormControl>
                      {errors.centerError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          The center must be selected
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="24%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Assign Role
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        sx={{ height: '45px' }}

                        value={selectedRole || "default"}
                        onChange={(e) => setSelectedRole(e.target.value)}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >
                        <MenuItem value="default">Select Role</MenuItem>
                        {roles.map((role) => (
                          <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                        ))}
                      </Select>
                      {errors.marfatError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide marfat name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default EditKarkun;
